// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-28
import React from 'react';
import css from './ServerMsg.module.scss';

/** Unsupported browser block screen. Renders before app initialisation, so
 *  localization and theming are unavailable — hardcoded strings and colors are intentional. */
const ServerMsg = () => (
    <div className={css.serverMsgContainer}>
        <div className={css.serverMsgBox}>
            <p className={css.serverMsg} data-testid='server-msg-text'>
                This site was designed for the latest version of Chrome, Firefox, Safari, and Microsoft Edge Chromium.
                Please use another internet browser.
            </p>
        </div>
    </div>
);

export default ServerMsg;